import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      maxWidth: 1224,
      width: '100%',
      margin: '0 auto',

      '& .MuiPaper-root': {
        width: '100%',
      },
    },
    close: {
      position: 'absolute',
      top: 25,
      right: 25,
    },
    icon: {
      fontSize: 40,
      marginBottom: 10,
    },
    content: {
      width: '100%',
    },

    img: {
      marginTop: 20,
      width: '100%',
      height: '100%',
      maxHeight: 648,
      objectFit: 'cover',
      objectPosition: 'center',
      borderRadius: 5,
    },

    buttonContainer: {
      width: '100%',
      textAlign: 'center',
    },

    buttonCls: {
      height: '66px !important',
      borderRadius: 8,
      textTransform: 'unset',
      fontSize: 14,
      margin: '10px 0 25px',
      maxWidth: 282,

      '& .MuiSvgIcon-root': {
        fontSize: 16,
        marginRight: 7,

        '& path': {
          fill: '#fff',
        },
      },
    },

    mediaContainer: {
      width: '100%',
      maxWidth: 1154,
    },
  }),
);
